import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import { AxiosError } from 'axios';
import {
  Card,
  Colors,
  IconName,
  Text,
  Typography,
  Icon,
} from 'goalsetter-webapp-components';
import useFetchData from 'app/hooks/useFetchData';
import {
  ButtonsContainer,
  Container,
  ImageGrid,
  StyledDescription,
  StyledTitle,
  buttonLeftIconStyle,
  buttonStyle,
  cardStyle,
  descriptionRegisteredTrademarkStyle,
  registeredTrademarkStyle,
} from './styles';
import { Trans } from 'react-i18next';
import GoalCardImage from 'app/components/GoalCardImage';
import { useLocation, useNavigate } from 'react-router-dom';
import { FamilyMember } from 'types/goals';
import CardsErrorModalModal from 'app/components/Modals/CardsErrorModal';
import { CardsEntity } from 'types/goalcard';
import { cardService } from 'api';
import { RoutesGs } from '../../../../router/RoutesList';
import { Button, Flex } from '@mantine/core';
import { sendAnalyticsEvent } from '../../../../utils/analytics/analyticsWrapper';
import { ActionType, CategoryType } from '../../../../types/analytics/enum';
import LogoHeader from 'app/components/LogoHeader';

export const SelectCard: React.FC = () => {
  const [filter, setFilter] = useState<string>('all');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<CardsEntity | null>(null);
  const { state } = useLocation();
  const navigate = useNavigate();
  const user = state?.selectedUser as FamilyMember;

  const goToCustomizeCard = () =>
    navigate(RoutesGs.CustomizeGoalcard, {
      state: {
        selectedUser: user,
        selectedCard: selectedCard,
      },
    });

  const { data, loading, fetchData, error } = useFetchData<
    CardsEntity[],
    AxiosError
  >();

  const filteredData = data?.filter((i: CardsEntity) => {
    if (filter === 'all') return i;
    return i.cardType === filter;
  });
  const options = t('selectCard.filterOptions', {
    returnObjects: true,
  }) as Array<{ id: number; value: string; label: string; icon: IconName }>;

  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    fetchData(cardService.getCards());
  }, []);

  useEffect(() => {
    if (!user) {
      navigate(-1);
    }
    if (error && !data) {
      setShowModal(true);
    }
  }, [user, error, data, navigate]);

  useEffect(() => {
    if (selectedCard) {
      goToCustomizeCard();
    }
  }, [goToCustomizeCard, selectedCard]);

  return (
    <Container>
      <CardsErrorModalModal
        show={showModal}
        onClose={handleCloseModal}
      />
      <LogoHeader />
      <StyledTitle>
        {/* TODO: Replace this component */}
        <Trans
          i18nKey={t('selectCard.title')}
          values={{
            name: user.firstname,
            reg: '®',
          }}
          components={{
            span: <span style={registeredTrademarkStyle} />,
          }}
        />
      </StyledTitle>
      <Card style={cardStyle}>
        <StyledDescription>
          {/* TODO: Replace this component */}
          <Trans
            i18nKey={t('selectCard.description')}
            values={{
              reg: '®',
            }}
            components={{
              span: <span style={descriptionRegisteredTrademarkStyle} />,
            }}
          />
        </StyledDescription>
        <ButtonsContainer>
          {options.map((i) => {
            const handleSelectFilter = () => setFilter(i.value);
            const isSelected = filter === i.value;
            return (
              <Button
                key={i.id}
                onClick={handleSelectFilter}
                style={buttonStyle(isSelected)}
              >
                <Flex
                  justify="center"
                  align="center"
                >
                  <Icon
                    icon={i.icon}
                    size={40}
                    color={isSelected ? Colors.WHITE : Colors.ORANGE}
                    style={buttonLeftIconStyle}
                  />
                  <Text
                    type={Typography.GSBUTTON}
                    color={isSelected ? Colors.WHITE : Colors.ORANGE}
                  >
                    {i.label}
                  </Text>
                </Flex>
              </Button>
            );
          })}
        </ButtonsContainer>
        <ImageGrid>
          {!loading &&
            filteredData &&
            filteredData.map((item: CardsEntity, index: number) => {
              const handleSelectCard = () => setSelectedCard(item);
              sendAnalyticsEvent(
                CategoryType.customizeGoalcardDesign,
                ActionType.Goalcard_CustomizeGoalcard_GoalcardDesign,
              );
              return (
                <div
                  key={index}
                  onClick={handleSelectCard}
                >
                  <GoalCardImage
                    showAnimation
                    imageURL={item.imageURL}
                  />
                </div>
              );
            })}
        </ImageGrid>
      </Card>
    </Container>
  );
};
